module.exports = __webpack_public_path__ + "img/menu.35e2aa56.svg";